import apiClient from './apiClient.js';

export const deleteEvent = async (event_id) => {
    const session_url = '/event';

    try {
        const response = await apiClient.delete(session_url, {
            data: {
                event_id: event_id,
            },
        });
        return response.data;
    } catch (err) {
        console.log(err.message);
        console.log(err.response);
        throw err;
    }
};
